import { request } from '@umijs/max';

// 获取订单分页列表
export async function getOrderListPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/order/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: [
        'shop',
        'brand',
        'category.parent.parent',
        'imageList',
        'attrList',
        'optionList',
      ],
    },
  });
}

// 获取订单详情
export async function getOrderListInfo(values: API.FormValues) {
  return request('/api/admin/order/info', {
    method: 'POST',
    data: {
      ...values,
      with: [
        'goodList',
        'payList',
        'refundList',
        'shop',
        'user',
        'operator',
        'streetAdminUser',
        'districtAdminUser',
        'leaseContracts',
        'payVouchers',
        'subsidyInvoices',
        'subsidyPromises'
      ],
    },
  });
}

// 街道审批
export async function streetVerifyOrder(values: API.FormValues) {
  return request('/api/admin/order/streetVerify', {
    method: 'POST',
    data: values,
  });
}

// 区县审批
export async function districtVerifyOrder(values: API.FormValues) {
  return request('/api/admin/order/districtVerify', {
    method: 'POST',
    data: values,
  });
}

// 结算开始
export async function settleBegin(values: API.FormValues) {
  return request('/api/admin/order/settleBegin', {
    method: 'POST',
    data: values,
  });
}

// 结算完成
export async function settleComplete(values: API.FormValues) {
  return request('/api/admin/order/settleComplete', {
    method: 'POST',
    data: values,
  });
}

// 导出订单
export async function exportOrderList(values: API.FormValues) {
  return request('/api/admin/order/export', {
    method: 'POST',
    data: values,
    responseType: 'blob',
  });
}
